import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/60 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">{appData.title}</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">{appData.description}</p>
            <div className="flex flex-wrap gap-3">
              {appData.features.map((f, i) => (
                <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs bg-secondary-500/10 text-secondary-400 rounded-full border border-secondary-500/20 whitespace-nowrap">
                  <i className="ri-check-line text-xs"></i>{f}
                </span>
              ))}
            </div>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-smartphone-line"></i>
                手机访问
              </a>
              <span className="text-xs text-foreground-600">或直接收藏本站至主屏幕</span>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56 flex items-center justify-center text-8xl text-primary-400/30">
            <i className="ri-smartphone-line"></i>
          </div>
        </div>
      </div>
    </section>
  );
}